import styled from 'styled-components';
import { animated } from '@react-spring/web';
import { APPBAR_HEIGHT } from '../../../src/styled/global-variables';
import { getSizeBy, getPropOrElse, getColor } from '../../../src/styled/utils';
export const StyledAppBar = styled(animated.header) `
  position: ${getPropOrElse(['position'], 'static')};
  top: ${getPropOrElse(['top'], 0)};
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${APPBAR_HEIGHT}px;
  padding: 0 ${getSizeBy(4)};
  background-color: ${({ color }) => (color ? getColor(color) : 'inherit')};
`;
